import { render, staticRenderFns } from "./BearbeiteHersteller.vue?vue&type=template&id=c2ff319e&"
import script from "./BearbeiteHersteller.vue?vue&type=script&lang=js&"
export * from "./BearbeiteHersteller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports